import {QuotationService} from '../services/quotation-service/quotation.service';
import {QuotationStep} from '../model/QuotationStep';
import {OnInit} from '@angular/core';
import {Router} from '@angular/router';

export class InsureStep implements OnInit {
  constructor(protected router: Router,
              protected quotationService: QuotationService,
             ) {
  }

  ngOnInit() {
  }

  goToStep(step: string) {
    this.quotationService.quotationStep = <QuotationStep>step;
    console.log('continued to ' + this.quotationService.quotationStep);
  }
}
